'use client';

import { useEffect, useState } from 'react';

export type BrandNames = {
  brandName: string;
  colorCount: number;
};

export function useBrandNames() {
  const [brands, setBrands] = useState<BrandNames[]>([]);

  useEffect(() => {
    fetch('/api/products/brands')
      .then((res) => res.json())
      .then(({ brands }) => setBrands(brands));
  }, []);

  return brands;
}
